var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.151 17.922c4.863 0 8.805-3.995 8.805-8.922 0-4.928-3.942-8.922-8.805-8.922C4.288.078.346 4.072.346 9c0 4.927 3.942 8.922 8.805 8.922z",
    fill: "#EE0005"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.091 17.922c4.863 0 8.806-3.995 8.806-8.922 0-4.928-3.943-8.922-8.805-8.922-4.863 0-8.806 3.994-8.806 8.922 0 4.927 3.943 8.922 8.806 8.922z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.286 9a9.004 9.004 0 0 0 .876 3.885 8.887 8.887 0 0 0 2.46 3.108 8.903 8.903 0 0 0 2.457-3.109 9.02 9.02 0 0 0 0-7.766 8.903 8.903 0 0 0-2.458-3.108 8.886 8.886 0 0 0-2.459 3.107 9.006 9.006 0 0 0-.876 3.884z",
    fill: "#FF6300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/masterCard.2aaa3bddd1a43851e8fa5dd0657ea38a.svg";
export { ForwardRef as ReactComponent };